import { useNavigate } from "react-router-dom";

export function useAppNavigate() {
	const navigate = useNavigate();
	const navigateToEcHome = () => {
		navigate(`/ec`);
	};

	const navigateToEcSeries = (id: number) => {
		navigate(`/ec/series/${id}`);
	};

	const navigateToEcCollect = () => {
		navigate(`/ec/collectList`);
	};

	const navigateToEcCollectFromLiffShare = () => {
		navigate(`/ec/collectList/from-liff-share`);
	};

	const navigateToEcProduct = (id: number) => {
		navigate(`/ec/product/${id}`);
	};
	return {
		navigateToEcHome,
		navigateToEcCollect,
		navigateToEcCollectFromLiffShare,
		navigateToEcProduct,
		navigateToEcSeries,
	};
}
